import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateModifierPrice(payload) {
    return requestPost(apiPath.MODIFIER_PRICE.path, payload)
  },

  GetOneModifierPrice(modifierPriceID) {
    return requestGet(`${apiPath.MODIFIER_PRICE.path}/${modifierPriceID}`)
  },

  GetAllModifierPrice(paging, sorting, filtering) {
    return requestGet(apiPath.MODIFIER_PRICE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_modifierItemCode: filtering.modifierItemCode,
      f_modifierGroupCode: filtering.modifierGroupCode,
      f_priceType: filtering.priceType,
      f_price: filtering.price
    })
  },

  UpdateModifierPrice(modifierPriceID, payload) {
    return requestPut(
      `${apiPath.MODIFIER_PRICE.path}/${modifierPriceID}`,
      payload
    )
  },

  DeleteModifierPrice(modifierPriceID) {
    return requestDelete(`${apiPath.MODIFIER_PRICE.path}/${modifierPriceID}`)
  }
}

export default api
